import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    userProfileMenu: {
        display: 'flex',
    },
    profileContainer: {
        position: 'relative',
    },
    button: {
        color: 'inherit',
        padding: '0.2rem 1rem',
    },
});
